'use client'

import { Suspense } from 'react'

/**
 * Contained Suspense boundary for per-block lazy chunks.
 * Fallback preserves host footprint to avoid layout shift while chunk loads.
 */
export function LazyBlockSurface({ children, hostClassName = 'nb-block-host' }) {
  return (
    <Suspense
      fallback={
        <div className={hostClassName} aria-hidden data-block-chunk-loading />
      }
    >
      {children}
    </Suspense>
  )
}
